module.exports = __webpack_public_path__ + "media/images/form-status-accepted-3ad31672.gif";